/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'unlink': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 9)" _stroke="#00272E"><path pid="0" d="M10 3.85h3c1.47.005 2.662 1.256 2.667 2.8v.7c-.005 1.544-1.196 2.795-2.667 2.8h-3"/><path pid="1" d="M6 3.85H3C1.53 3.855.338 5.106.333 6.65v.7C.338 8.894 1.53 10.145 3 10.15h3"/><path pid="2" d="M8 2.45V.35"/><path pid="3" d="M10 2.1l1-1.05"/><path pid="4" d="M6 2.1L5 1.05"/><path pid="5" d="M8 11.55v2.1"/><path pid="6" d="M10 11.9l1 1.05"/><path pid="7" d="M6 11.9l-1 1.05"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/unlink.js